<template>
	<header
		class="header"
		style="min-height:100vh;margin-bottom:-200px;"
		:style="{
			'background-image':
				'linear-gradient(rgba(0, 0, 0, 0.3), rgb(0, 0, 0)),url(' + bgImg + ')',
		}"
	>
		<div class="header__show-name">
			<h1><span>Ibaka</span>Tv</h1>
			<h2>Extra Value, At No Cost</h2>
			<h3>
				Watch thousands of your favourite Blockbuster movies and tv series at
				your convenience. STREAM. CAST. DOWNLOAD. PAUSE SUBSCRIPTION. 14 DAYS
				FREE
			</h3>
		</div>
	</header>
</template>

<script>
export default {
	name: "Header",
	data() {
		return {
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>

<style lang="scss">
.header {
	position: relative;
	height: 90vh;
	background-image: url("../assets/header-bg.png");
	background-size: cover;
	margin-bottom: -200px;
	&__show-name {
		position: absolute;
		display: flex;
		flex-direction: column;
		z-index: 99;
		top: 11vh;
		left: 3vw;
		text-align: left;
		color: white;
		p {
			width: 50%;
			font-weight: 100;
		}
		h3 {
			font-size: 1.5em;
		}
		h2 {
			font-weight: 100;
			align-self: flex-start;
			span {
				font-weight: bold;
			}
		}
		img {
			margin: 0;
			width: 500px;
		}
	}
	& > img {
		width: 70%;
		position: fixed;
		top: 0;
		right: 0;
	}
}
</style>

<style>
header {
}
.header__show-name {
	color: #fff;
	text-shadow: 1px 1px 5px #333;
}
.header__show-name h3 {
	width: 50%;
}
</style>
